import * as React from "react";
import { Link } from "react-router-dom";
import { Viewport, ViewMedium, ViewLarge, ViewSmall } from "bernie-view";
import { UitkCard, UitkCardContent, UitkCardTextSegment } from "uitk-react-cards";
import { UitkLink } from "uitk-react-link";
import { UitkText } from "uitk-react-text";
import { inject, observer } from "mobx-react";

export interface NotificationBannerBEXProps {
  heading: string | undefined;
  message: string;
  linkText: string | undefined;
  dialogQuery: string | undefined;
  onClickEvent: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

export const NotificationBannerBEX = inject("routeStore")(
  observer((props: NotificationBannerBEXProps) => {
    const { heading, message, onClickEvent, dialogQuery, linkText } = props;
    const mobileViewClasses =
      "bex-travel-advisory-with-chatbot-link uitk-flat-border-top uitk-flat-border-bottom all-x-padding-three all-y-padding-three";

    return (
      <Viewport>
        <ViewSmall>
          <UitkCard withBorder={false} className={mobileViewClasses}>
            <UitkCardContent className="uitk-type-center">
              <UitkCardTextSegment>
                <UitkText align="left" size={300}>
                  <UitkText inline={true} weight="bold">
                    {heading}
                  </UitkText>{" "}
                  <UitkText inline={true}>{message}</UitkText>{" "}
                </UitkText>
                <UitkText align="left" size={300} className="all-t-padding-three">
                  <UitkLink onClick={onClickEvent} inline={true} className={"link"}>
                    <Link role="button" to={{ search: dialogQuery }}>
                      {linkText}
                    </Link>
                  </UitkLink>
                </UitkText>
              </UitkCardTextSegment>
            </UitkCardContent>
          </UitkCard>
        </ViewSmall>
        <ViewMedium>
          <UitkCard withBorder={false} className="bex-travel-advisory-with-chatbot-link">
            <UitkCardContent className="uitk-type-center">
              <UitkCardTextSegment>
                <UitkText align="left" size={300}>
                  <UitkText inline={true} weight="bold">
                    {heading}
                  </UitkText>{" "}
                  <UitkText inline={true}>{message}</UitkText>{" "}
                </UitkText>
                <UitkText align="left" size={300} className="all-t-padding-three">
                  <UitkLink onClick={onClickEvent} inline={true} className={"link"}>
                    <Link role="button" to={{ search: dialogQuery }}>
                      {linkText}
                    </Link>
                  </UitkLink>
                </UitkText>
              </UitkCardTextSegment>
            </UitkCardContent>
          </UitkCard>
        </ViewMedium>
        <ViewLarge>
          <UitkCard withBorder={false} className="bex-travel-advisory-with-chatbot-link">
            <UitkCardContent className="uitk-type-center">
              <UitkCardTextSegment>
                <UitkText align="center" size={300}>
                  <UitkText inline={true} weight="bold">
                    {heading}
                  </UitkText>{" "}
                  <UitkText inline={true}>{message}</UitkText>{" "}
                  <UitkLink onClick={onClickEvent} inline={true} className="link">
                    <Link role="button" to={{ search: dialogQuery }}>
                      {linkText}
                    </Link>
                  </UitkLink>
                </UitkText>
              </UitkCardTextSegment>
            </UitkCardContent>
          </UitkCard>
        </ViewLarge>
      </Viewport>
    );
  })
);
